import React, { useState, useEffect, Suspense, lazy } from "react";
import { Tab, Row, Col, Nav, Container } from "react-bootstrap";
import TitleCommon from "../components/TitleCommon";
import Layout from "../Layout";
import { StyledTabs } from "../components/StyledCommon";
import ReactTooltip from "react-tooltip";
import { useTranslation } from "react-i18next";
import {
  useHistory,
  useRouteMatch,
  useParams,
  useLocation,
} from "react-router-dom";
import axios from "axios";
import { API_ROUTE, getData, headersRequest } from "../helpers";
import DeliveryDashboard from "../components/pharos/DeliveryDashboard";
import AvailableResource from "../components/GanttDx/ResourcesAsig/AvailableResource";
import { useDispatch, useSelector } from "react-redux";
import { fetchUsers } from "../redux";
import MetriCard from "../components/pharos/components/MetriCard";

import Workers from "../components/pharos/assets/workers.png";
import styles from "../components/pharos/DeliveryDashboard.module.css";
import DashboardResourceCluster from "../components/ResourcePerformance/DashboardResourceCluster";
import Swal from "sweetalert2";
import { PerformanceServices } from "../components/ResourcePerformance/PerformanceServices";
import _ from "lodash";

const DashboardClusterPharos = () => {
  const [usersCluster, setUsersCluster] = useState([]);
  const [projectByCluster, setProjectByCluster] = useState("");
  const { IdCluster, Cluster } = useParams();

  const getUserByCluster = async () => {
    try {
      const result = await axios.get(
        `${API_ROUTE}delivery-dashboard-cluster-headers/${IdCluster}`,
        headersRequest()
      );
      if (result.status == 200) {
        setUsersCluster(result.data.infoUsersCluster[0].CantidadDeUsuarios);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const getProjects = async () => {
    try {
      const result = await PerformanceServices.getAllProjects();
      const proj = _.filter(result, { Cluster: Cluster });
      setProjectByCluster(proj);
    } catch (error) {
      Swal.fire("Error", error, "error");
    }
  };

  useEffect(() => {
    getProjects();
    getUserByCluster();
  }, []);

  return (
    <>
      <Layout>
        <TitleCommon
          title={{
            text: `Cluster - ${Cluster}`,
            icon: "cloud",
          }}
          goBack={{
            text: "Volver",
            icon: "arrow-left",
          }}
        />
        <Container className="mt-4" fluid style={{ maxWidth: "1400px" }}>
          <div className="d-flex flex-column">
            <DashboardResourceCluster
              IdCluster={IdCluster}
              ClusterParams={Cluster}
              usersCluster={usersCluster}
              projectByCluster={projectByCluster}
            />
            {/* <AvailableResource resources={usersCluster} /> */}
          </div>
        </Container>
      </Layout>
    </>
  );
};

export default DashboardClusterPharos;
